import DataDownloadList from './data-download-list/data-download-list.vue';
export default [
  {
    path: 'data-download-list',
    name: 'dataDownloadList',
    component: DataDownloadList
  }
];
